import { render, staticRenderFns } from "./quxiaorechange.vue?vue&type=template&id=ff140ede&scoped=true&"
import script from "./quxiaorechange.vue?vue&type=script&lang=js&"
export * from "./quxiaorechange.vue?vue&type=script&lang=js&"
import style0 from "./quxiaorechange.vue?vue&type=style&index=0&id=ff140ede&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff140ede",
  null
  
)

export default component.exports